import React, { forwardRef } from 'react'

type FileInputProps = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const FileInput = forwardRef<HTMLInputElement, FileInputProps>(({ onChange }, ref) => {
  return <input ref={ref} type="file" className="hidden" onChange={onChange} />
})

FileInput.displayName = 'FileInput'

export default FileInput
